// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titolo {
  display: inline-flex;
  align-items: center;
}

.page-container {
  transition: all 20s ease !important;
}

ion-content {
  --background: rgb(255, 255, 255) !important;
}

.logo-pn {
  height: 3rem;
  width: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;AACF;;AACA;EACE,mCAAA;AAEF;;AAAA;EACE,2CAAA;AAGF;;AADA;EACE,YAAA;EACA,WAAA;AAIF","sourcesContent":[".titolo {\n  display: inline-flex;\n  align-items: center;\n}\n.page-container {\n  transition: all 20s ease !important;\n}\nion-content {\n  --background: rgb(255, 255, 255) !important;\n}\n.logo-pn {\n  height: 3rem;\n  width: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
